<template>
  <div class="list-image-uploader border d-flex w-100 align-items-stretch h-100 position-relative flex-column hover-cursor">
    <div @click="showImageGallery"
         class="draggable-area w-100 d-flex align-items-center justify-content-center">
      <img class="thumbnail" v-if="src" style="z-index: 4;width: 100px" :src="src" />
    </div>
    <image-viewer ref="imageViewer"/>
  </div>
</template>

<script>
  import ImageViewer from "./../image-viewer/ImageViewer";
  import {uuid} from 'vue-uuid';


  export default {
    name: "InternalImagesViewer",
    components: {ImageViewer},
    props: {
      internalImages: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
      }
    },
    computed: {
      src() {
        if (!this.internalImages) {
          return null;
        }

        // Returns first image of the array
        for (let img of this.internalImages) {
          return img.url
        }
        return null;
      },
    },
    methods: {
      showImageGallery() {
        if (!this.src) {
          return;
        }
        let position = 0
        let items = this.internalImages.map(i => {
          position += 1
          return {
            data: {original: {url: i.url}},
            position: position,
            uuid: uuid.v4(),
          }
        })
        this.$refs.imageViewer.show({
          items: items,
          title: this.$i18n.t('Internal Images')
        });
      },
    }
  }
</script>

<style scoped lang="scss">
</style>
